<template>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div>
            <div style="padding: 10px 20px;border: 1px solid rgb(238, 238, 238);background: white;" >
                <h4 class="sub-title" >Payment Detail <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-if="!isEdit" @click="isEdit = true;"><span class="glyphicon glyphicon-pencil"></span> Edit</a></h4>
                <hr>
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-sm-3">
                        <label for="">Normal Charge</label>
                        <!-- <img src="/static/img/assets/setting/shipping/thailandpost_logo.png" alt="thailand post logo" style="height: 50px;"> -->
                    </div>
                    <div class="col-sm-6" v-if="normal_charge">
                        <template v-if="isEdit">
                            <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control" v-model="normal_charge.contentvalue">
                        </template>
                        <template v-else>
                            ฿ {{normal_charge.contentvalue | numberFormat}}
                        </template>
                    </div>
                    
                </div>
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-sm-3">
                        <label for="emsCharge">EMS Charge</label>
                        <!-- <img src="/static/img/assets/setting/shipping/ems_logo.png" alt="ems logo" style="height: 50px;"> -->
                    </div>
                    <div class="col-sm-6" v-if="ems_charge">
                        <template v-if="isEdit">
                            <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control" v-model="ems_charge.contentvalue">
                        </template>
                        <template v-else>
                            ฿ {{ems_charge.contentvalue | numberFormat}}
                        </template>
                    </div>
                </div>
                <div class="row" style="margin-bottom: 15px;">
                    <div class="col-sm-3">
                        <label for="emsCharge">Kerry Charge</label>
                    </div>
                    <div class="col-sm-6" v-if="kerry_charge">
                        <template v-if="isEdit">
                            <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control" v-model="kerry_charge.contentvalue">
                        </template>
                        <template v-else>
                            ฿ {{kerry_charge.contentvalue | numberFormat}}
                        </template>
                    </div>
                </div>
                
                <div class="row" style="margin-bottom: 15px;">

                    <div class="col-sm-3">
                        <label for="additionalProductCharge">Additional Product Charge	</label>
                    </div>
                    <div class="col-sm-6" v-if="additionalproduct_charge">
                        <template v-if="isEdit">
                            <input type="text" pattern="[0-9]*" inputmode="numeric" class="form-control" v-model="additionalproduct_charge.contentvalue">
                        </template>
                        <template v-else>
                            ฿ {{additionalproduct_charge.contentvalue | numberFormat}}
                        </template>
                    </div>
                </div>

                <div class="text-center" style="margin-bottom: 25px;">
                    <template v-if="isEdit">
                        <a href="javascript:void(0);" class="btn btn-default" @click="reset">Cancel</a>
                        <a href="javascript:void(0);" class="btn btn-primary" @click="saveContent">Save</a>
                    </template>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios'
import api from '@/api'
import config from '@/config'
import uploadfile from '@/components/elements/uploadfile'

export default {
    props: ['init'],
    data: function(){
        return {
            isEdit: false, 

            normal_charge: undefined,
            ems_charge: undefined,
            kerry_charge: undefined,
            additionalproduct_charge: undefined,
        }
    },
    components: {
        uploadfile
    },
    created() {
        var vm = this
    },
    created: function(){
        this.normal_charge = Object.assign({}, this.init.normal_charge);
        this.ems_charge = Object.assign({}, this.init.ems_charge);
        this.kerry_charge = Object.assign({}, this.init.kerry_charge);
        this.additionalproduct_charge = Object.assign({}, this.init.additionalproduct_charge);
        
        //cache
        this.cached_normal_charge = Object.assign({}, this.init.normal_charge);
        this.cached_ems_charge = Object.assign({}, this.init.ems_charge);
        this.cached_kerry_charge = Object.assign({}, this.init.kerry_charge);
        this.cached_additionalproduct_charge = Object.assign({}, this.init.additionalproduct_charge);
       
    },
    methods: {
        reset: function(){
            var vm = this
            this.normal_charge = Object.assign({}, this.cached_normal_charge);
            this.ems_charge = Object.assign({}, this.cached_ems_charge);
            this.kerry_charge = Object.assign({}, this.cached_kerry_charge);
            this.additionalproduct_charge = Object.assign({}, this.cached_additionalproduct_charge);
            
            vm.isEdit = false

            vm.$emit('reset')
        },
        saveContent: function(){
            var vm = this
            vm.sendRequest(this.normal_charge)
            vm.sendRequest(this.ems_charge)
            vm.sendRequest(this.kerry_charge)
            vm.sendRequest(this.additionalproduct_charge)
            
            this.cached_normal_charge = Object.assign({}, this.normal_charge);
            this.cached_ems_charge = Object.assign({}, this.ems_charge);
            this.cached_kerry_charge = Object.assign({}, this.kerry_charge);
            this.cached_additionalproduct_charge = Object.assign({}, this.additionalproduct_charge);
            
            vm.isEdit = false
        },
        onUploaded: function(image){
            this.banktransferinfo_photo.contentvalue = image
        },
        sendRequest: function(content,callback){
            var vm = this
            api.updateConfig(content,function(error,response){
                if (error) {
                    console.error(error)
                    return
                }
            })
        }
    },
    watch: {
        init: function(){
            this.normal_charge = Object.assign({}, this.init.normal_charge);
            this.ems_charge = Object.assign({}, this.init.ems_charge);
            this.kerry_charge = Object.assign({}, this.init.kerry_charge);
            this.additionalproduct_charge = Object.assign({}, this.init.additionalproduct_charge);
            
            
            //cache
            this.cached_normal_charge = Object.assign({}, this.init.normal_charge);
            this.cached_ems_charge = Object.assign({}, this.init.ems_charge);
            this.cached_kerry_charge = Object.assign({}, this.init.kerry_charge);
            this.cached_additionalproduct_charge = Object.assign({}, this.init.additionalproduct_charge);
            
        }
    }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetail.vue